import Wrapper from "../assets/wrappers/Choice";
import { BiTime } from "react-icons/bi";
import { RiCustomerServiceFill } from "react-icons/ri";
import { AiOutlineCheck } from "react-icons/ai";

const Choice = () => {
  return (
    <Wrapper>
      <div className="container">
        <h3>What Makes Us the Best Choice?</h3>
        <div className="content">
          <div className="item">
            <div className="header">
              <div className="icon-container">
                <RiCustomerServiceFill className="icon" />
              </div>
              <h4>Expert Care</h4>
            </div>

            <ul>
              <li>
                <AiOutlineCheck className="checked-icon" /> Doctorate in Physical Therapy
              </li>
              <li>
                <AiOutlineCheck className="checked-icon" /> Years of Clinical Experience
              </li>
            </ul>
          </div>
          <div className="item">
            <div className="header">
              <div className="icon-container">
                <AiOutlineCheck className="icon" />
              </div>

              <h4>Personalized Treatment</h4>
            </div>
            <ul>
              <li>
                {" "}
                <AiOutlineCheck className="checked-icon" /> Tailored Recovery Plans
              </li>
              <li>
                {" "}
                <AiOutlineCheck className="checked-icon" /> One-on-One Sessions
              </li>
            </ul>
          </div>
          <div className="item">
            <div className="header">
              <div className="icon-container">
                <BiTime className="icon" />
              </div>
              <h4>Evidence Based</h4>
            </div>

            <ul>
              <li>
                <AiOutlineCheck className="checked-icon" /> Latest Rehabilitation Techniques
              </li>
              <li>
                <AiOutlineCheck className="checked-icon" /> Proven Results
              </li>
            </ul>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default Choice;
